import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Constants } from '../../../../environments/constantes';

@Component({
    selector: 'about-modal',
    templateUrl: './about-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AboutModalComponent {

  readonly supportUrl: string = Constants.supportWhatsappUrl;

  constructor(private dialogRef: MatDialogRef<AboutModalComponent>) { }

  close(): void {
    this.dialogRef.close();
  }

}
